import React, { useEffect } from "react";
import { Typography, Box, Grid, Card, useMediaQuery } from "@mui/material";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import SubFooterView from "components/SubFooterView";
import FooterView from "components/FooterView";
import mobileTopArc from "assets/images/mobile-top-curve.svg";
import { Link } from "react-router-dom";

const SiteMap = (props) => {
  const { organizationInfo } = props;
  const matches = useMediaQuery("(max-width:600px)");
  const isSmallScreen = useMediaQuery("(max-width:1000px)");
  const isLoggedIn = JSON.parse(sessionStorage.getItem("isLoggedIn"));
  const appData = JSON.parse(sessionStorage.getItem("applicationData"));
  const isShowBackgroundAssets =
    organizationInfo?.organizationOptionJson?.showBackgroundAssetsFlag?.toUpperCase() ===
    "Y";
  const isShowAppStoreBand =
    organizationInfo?.organizationOptionJson?.showAppStoreBand?.toLowerCase() ===
    "y";

  useEffect(() => {
    document.getElementById("appcontent").scroll(0, 0);
    props.setValue(5);
  }, []);

  let siteMapLeftData = [
    {
      id: 0,
      text: "Home",
      link: "/",
    },
    {
      id: 1,
      text: "Search for Medication",
      link: "/SearchMedication",
    },
    {
      id: 2,
      text: "How It Works",
      link: "/how-cuverd-works",
    },
    {
      id: 3,
      text: "FAQs",
      link: "/frequently-asked-questions",
    },
    {
      id: 4,
      text: "Terms and Conditions",
      link: "/terms-and-conditions",
    },
    {
      id: 5,
      text: "Privacy",
      link: "/privacy-policy",
    },
    {
      id: 6,
      text: "Contact Us",
      link: "/contact-us",
    },
  ];

  if (isShowAppStoreBand) {
    siteMapLeftData.push({
      id: 7,
      text: "Download on the App Store",
      isPlayStore: true,
      link: `${appData?.app?.appStoreUrl}`,
    });
    siteMapLeftData.push({
      id: 8,
      text: "Get it on Google Play",
      isPlayStore: true,
      link: `${appData?.app?.googlePlayStoreUrl}`,
    });
  }

  const postLoginMenu = [
    {
      id: 9,
      text: "My Coupons",
      link: "/MyAccount/MyCoupons",
      signinLink: "/sign-up",
    },
    {
      id: 10,
      text: "Profile",
      link: "/MyAccount/Profile",
      signinLink: "/sign-up",
    },
    {
      id: 11,
      text: "Settings",
      link: "/MyAccount/Settings",
      signinLink: "/sign-up",
    },
    {
      id: 12,
      text: "Cuverd® Settings",
      link: "/CuverdSettings",
      signinLink: "/sign-up",
    },
    {
      id: 13,
      text: "Messages",
      link: "/Notifications",
      signinLink: "/sign-up",
    },
  ];

  let siteMapRightData = [
    {
      id: 14,
      text: "About Us",
      link: "/aboutus",
      signinLink: "/aboutus",
    },
  ];

  let Subtitles = [];

  if (
    organizationInfo?.organizationOptionJson?.signInOutFlag?.toUpperCase() ===
    "Y"
  ) {
    siteMapRightData = [...postLoginMenu, ...siteMapRightData];
    Subtitles = [
      {
        id: 15,
        text: "Change Password",
        link: "/ChangePassword",
        signinLink: "/sign-up",
      },
      {
        id: 16,
        text: "Change Phone Number",
        link: "/ChangePhoneNumber",
        signinLink: "/sign-up",
      },
      {
        id: 17,
        text: "Change Email Address",
        link: "/ChangeEmailAddress",
        signinLink: "/sign-up",
      },
    ];
  }

  return (
    <Box sx={{ overflowY: "auto" }}>
      <Helmet>
        <title>
          Sitemap |{" "}
          {organizationInfo?.app?.appCode === "CVD"
            ? "Cuverd® Partner"
            : "Cuverd®"}
        </title>
        <meta
          name="description"
          content="The Sitemap for the Cuverd prescription medication savings and discount mobile app and website."
        />
        <meta property="og:title" content="Sitemap | Cuverd®" />
        <meta
          property="og:description"
          content="The Sitemap for the Cuverd prescription medication savings and discount mobile app and website."
        />
        <meta
          property="og:image"
          content="assets/images/cuverd-logo-header.png"
        />
        <link
          rel="alternate"
          href="https://www.cuverd.com/sitemap"
          hrefLang="en-us"
        />
        <link rel="canonical" href="https://www.cuverd.com/sitemap" />
      </Helmet>
      {isShowBackgroundAssets && (
        <Box sx={{ display: matches ? "block" : "none" }}>
          <img
            src={mobileTopArc}
            alt="mabile-arc"
            className="left-mobile-arc"
            style={{ transform: "rotate(180deg)" }}
          />
        </Box>
      )}
      <Box>
        <Grid container alignItems="center">
          <Grid
            item
            sm={12}
            xs={12}
            mt={2}
            mb={2}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Card
              sx={{
                minHeight: "600px",
                minWidth: "75vw",
                maxWidth: "75vw",
                paddingLeft: isSmallScreen ? "2rem" : "12rem",
                paddingRight: isSmallScreen ? "2rem" : "12rem",
                paddingTop: "3rem",
                paddingBottom: "3rem",
              }}
            >
              <Grid item container>
                <Grid item sm={6} xs={12}>
                  {siteMapLeftData.map((item) => {
                    return (
                      <Grid
                        key={item.id}
                        sx={{ display: "flex", alignItems: "center" }}
                        item
                        sm={12}
                      >
                        <Box
                          component="span"
                          sx={{ fontSize: "25px", marginRight: "5px" }}
                        >
                          &#8226;
                        </Box>

                        {item?.isPlayStore ? (
                          <Box
                            sx={{
                              cursor: "pointer",
                              textDecorationColor: "#003D4C",
                            }}
                          >
                            <a
                              rel="noreferrer"
                              target="_blank"
                              style={{
                                textDecoration: "underline",
                                textDecorationColor: "#003D4C",
                              }}
                              href={item?.link}
                            >
                              <Typography
                                variant="h4LatoBold"
                                sx={{ lineHeight: "2rem" }}
                              >
                                {item.text}
                              </Typography>
                            </a>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              cursor: "pointer",
                              textDecorationColor: "#003D4C",
                            }}
                            component={Link}
                            to={item.link}
                          >
                            <Typography
                              variant="h4LatoBold"
                              sx={{ lineHeight: "2rem" }}
                            >
                              {item.text}
                            </Typography>
                          </Box>
                        )}
                      </Grid>
                    );
                  })}
                </Grid>
                <Grid item sm={6} xs={12}>
                  <Grid item sm={12}>
                    {siteMapRightData.map((record, index) => {
                      return (
                        <Box key={record.id}>
                          <Grid item sm={12}>
                            <Box
                              component="span"
                              sx={{ fontSize: "25px", marginRight: "5px" }}
                            >
                              &#8226;
                            </Box>
                            <Box component="span">
                              <Box
                                component={Link}
                                to={
                                  isLoggedIn ? record.link : record.signinLink
                                }
                              >
                                <Typography
                                  variant="h4LatoBold"
                                  sx={{
                                    lineHeight: "2rem",
                                    textDecoration: "underline",
                                    textDecorationColor: "#003d4c",
                                  }}
                                >
                                  {record.text}
                                </Typography>
                              </Box>
                              {index !== 5 &&
                              !isLoggedIn &&
                              organizationInfo?.organizationOptionJson?.signInOutFlag?.toUpperCase() ===
                                "Y" ? (
                                <Box
                                  component={Link}
                                  to={
                                    isLoggedIn ? record.link : record.signinLink
                                  }
                                  sx={{
                                    paddingLeft: "4px",
                                    textDecoration: "none",
                                    cursor: "pointer",
                                  }}
                                >
                                  <Typography
                                    variant="h4LatoBold"
                                    sx={{ fontSize: "14px" }}
                                  >
                                    — Sign up required
                                  </Typography>
                                </Box>
                              ) : null}
                            </Box>
                            {index === 1
                              ? Subtitles.map((item) => {
                                  return (
                                    <Box key={item.id}>
                                      <Box
                                        sx={{
                                          marginLeft: "20px",
                                        }}
                                        component="span"
                                      >
                                        <Box
                                          component={Link}
                                          to={
                                            isLoggedIn
                                              ? item.link
                                              : item.signinLink
                                          }
                                        >
                                          <Typography
                                            variant="h4LatoBold"
                                            sx={{
                                              lineHeight: "2rem",
                                              fontSize: matches
                                                ? "12px"
                                                : undefined,
                                              textDecoration: "underline",
                                              textDecorationColor: "#003d4c",
                                            }}
                                          >
                                            {item.text}
                                          </Typography>
                                        </Box>

                                        {!isLoggedIn ? (
                                          <Box
                                            sx={{
                                              paddingLeft: "4px",
                                              textDecoration: "none",
                                              cursor: "pointer",
                                            }}
                                            component={Link}
                                            to={
                                              isLoggedIn
                                                ? item.link
                                                : item.signinLink
                                            }
                                          >
                                            <Typography
                                              variant="h4LatoBold"
                                              sx={{ fontSize: "14px" }}
                                            >
                                              — Sign up required
                                            </Typography>
                                          </Box>
                                        ) : null}
                                      </Box>
                                    </Box>
                                  );
                                })
                              : null}
                          </Grid>
                        </Box>
                      );
                    })}
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <SubFooterView />
        <FooterView />
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data || {},
  };
};

export default connect(mapStateToProps)(SiteMap);
